import { ChangeEvent, KeyboardEvent, useState } from 'react';
import { Box, IconButton, InputBase, Paper } from '@mui/material';
import { Icon } from '@iconify/react';
import { useRouter } from 'next/router';

interface Props {
  defaultQuery?: string;
}

export default function GlobalSearchBar({ defaultQuery = '' }: Props) {
  const router = useRouter();
  const [query, setQuery] = useState<string>(defaultQuery);

  const handleSearch = () => {
    if (query.trim().length > 0) {
      router.push({ pathname: '/search/unified', query: { q: query.trim() } });
    }
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: 3,
        px: 2,
        py: 0.5,
        background: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(129,140,248,0.3)',
        backdropFilter: 'blur(8px)',
        '&:focus-within': {
          border: '1px solid rgba(129,140,248,0.7)',
          boxShadow: '0 0 0 3px rgba(99,102,241,0.15)',
        },
      }}
    >
      <Icon
        icon="iconamoon:search-thin"
        style={{ fontSize: 22, color: '#818cf8', marginRight: 8 }}
      />
      <InputBase
        fullWidth
        value={query}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder="Search publications, organizations, technologies, people…"
        autoFocus
        sx={{
          color: '#c084fc',
          fontSize: '1.05rem',
          '& ::placeholder': { color: '#64748b' },
        }}
        inputProps={{ 'aria-label': 'global search' }}
      />
      <Box sx={{ ml: 1 }}>
        <IconButton
          onClick={handleSearch}
          size="small"
          disabled={query.trim().length === 0}
          sx={{
            color: '#818cf8',
            '&:hover': { backgroundColor: 'rgba(99,102,241,0.12)' },
            '&.Mui-disabled': { color: '#374151' },
          }}
        >
          <Icon icon="iconoir:nav-arrow-right" style={{ fontSize: 22 }} />
        </IconButton>
      </Box>
    </Paper>
  );
}
